import Loading from 'vue-loading-overlay'
import axios from 'axios'
import * as config from '@/config.json'

export default {
  name: 'BotTalkBound',
  components: {
    Loading,
    TableSkeleton: () => import('../../../components/TableSkeleton.vue')
  },
  data: () => {
    return {
      isLoading: false,
      isBusy: false,
      activeTab: 'totem', // 'totem' ou 'site'
      selected: [],
      selectedSites: [],
      selectedOptionCompany: null,
      optionsCompany: [],
      selectedOptionSpeechs: null,
      optionsSpeechs: [],
      selectMode: 'multi',
      selectModeMobile: 'multi',
      currentPage: 1,
      perPage: 4,
      pos: [],
      sites: [],
      fieldsPos: [
        {
          key: 'selected',
          label: 'Selecionado'
        },
        {
          key: 'number',
          label: 'Número'
        },
        {
          key: 'fullName',
          label: 'Descrição'
        },
        {
          key: 'inactive',
          label: 'Ativo'
        }
      ],

      fieldsSites: [
        {
          key: 'selected',
          label: 'Selecionado'
        },
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'siteCorporateName',
          label: 'Nome Corporativo'
        },
        {
          key: 'siteName',
          label: 'Nome do Site'
        },
        {
          key: 'inactive',
          label: 'Ativo'
        }
      ],

      fieldsPosMobile: [
        {
          key: 'selected',
          label: ''
        },
        {
          key: 'fullName',
          label: 'Descrição'
        },
        {
          key: 'inactive',
          label: 'Ativo'
        }
      ],

      fieldsSitesMobile: [
        {
          key: 'selected',
          label: ''
        },
        {
          key: 'siteCorporateName',
          label: 'Nome Corporativo'
        },
        {
          key: 'siteName',
          label: 'Nome do Site'
        },
        {
          key: 'inactive',
          label: 'Ativo'
        }
      ]
    }
  },

  methods: {
    redirect() {
      const ref = localStorage.getItem('redirectBotBound') ? localStorage.getItem('redirectBotBound') : 'home'

      localStorage.removeItem('redirectBotBound')
      this.$router.push(ref)
    },

    setActiveTab(tab) {
      this.activeTab = tab
      if (tab === 'totem') {
        this.clearSelected()
        if (this.selectedOptionSpeechs) {
          this.getPosSpeechs(this.selectedOptionSpeechs)
        }
      } else if (tab === 'site') {
        this.clearSelectedSites()
        if (this.selectedOptionSpeechs) {
          this.getSitesSpeechs(this.selectedOptionSpeechs)
        }
      }
    },

    handleTabChange(tabIndex) {
      const tabName = tabIndex === 0 ? 'totem' : 'site'
      this.setActiveTab(tabName)
    },

    onSpeechChange() {
      if (this.selectedOptionSpeechs) {
        // Carrega dados para a aba atual
        if (this.activeTab === 'totem') {
          this.getPosSpeechs(this.selectedOptionSpeechs)
        } else {
          this.getSitesSpeechs(this.selectedOptionSpeechs)
        }
      } else {
        // Limpa os dados quando nenhuma fala estiver selecionada
        this.pos = []
        this.sites = []
        this.selected = []
        this.selectedSites = []
      }
    },

    onRowSelected(items) {
      if (this.activeTab === 'totem') {
        this.selected = items
      } else {
        this.selectedSites = items
      }
    },

    selectAllRows() {
      if (this.activeTab === 'totem') {
        this.$refs.selectablePos?.selectAllRows()
        this.$refs.selectablePosMobile?.selectAllRows()
      } else {
        this.$refs.selectableSites?.selectAllRows()
        this.$refs.selectableSitesMobile?.selectAllRows()
      }
    },

    clearSelected() {
      this.$refs.selectablePos?.clearSelected()
      this.$refs.selectablePosMobile?.clearSelected()
      this.selected = []
    },

    clearSelectedSites() {
      this.$refs.selectableSites?.clearSelected()
      this.$refs.selectableSitesMobile?.clearSelected()
      this.selectedSites = []
    },

    async getNotification(title, body, type) {
      this.$vToastify.setSettings({
        position: 'bottom-center'
      })
      await this.$vtNotify({
        title: title,
        body: body,
        type: type,
        duration: 3000
      })
    },

    async buildDataBound(speechId, idsPOS) {
      const arrayPOS = idsPOS.map(idPOS => idPOS.id)

      const posIds = new Array(arrayPOS.join(','))
      return {
        speechId,
        posIds
      }
    },

    async buildDataBoundSite(speechId, idsSites) {
      const arraySites = idsSites.map(idSite => idSite.id)

      const siteIds = new Array(arraySites.join(','))
      return {
        speechId,
        siteIds
      }
    },

    async boundSpeech() {
      // Validações básicas
      if (!this.selectedOptionSpeechs) {
        await this.$alert('Por favor, selecione uma fala!', 'Atenção', 'warning')
        return
      }

      if (this.activeTab === 'totem') {
        if (!this.selected || this.selected.length === 0) {
          await this.$alert('Por favor, selecione pelo menos um totem!', 'Atenção', 'warning')
          return
        }
        await this.boundSpeechToPos()
      } else {
        if (!this.selectedSites || this.selectedSites.length === 0) {
          await this.$alert('Por favor, selecione pelo menos um site!', 'Atenção', 'warning')
          return
        }
        await this.boundSpeechToSite()
      }
    },

    async boundSpeechToPos() {
      this.isLoading = true

      const url = `${config.default.urlBase}/companies/speech/bound`
      const data = await this.buildDataBound(this.selectedOptionSpeechs, this.selected)

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          await this.$alert(`Fala do totem vinculada!`, 'Sucesso', 'success')

          this.pos = []
          this.selected = []
          this.getPosSpeechs(this.selectedOptionSpeechs)
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao cadastrar a fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async boundSpeechToSite() {
      this.isLoading = true

      const url = `${config.default.urlBase}/site/speech/bound`
      const data = await this.buildDataBoundSite(this.selectedOptionSpeechs, this.selectedSites)

      try {
        const response = await axios({
          url,
          method: 'post',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          await this.$alert(`Fala do site vinculada!`, 'Sucesso', 'success')

          this.sites = []
          this.selectedSites = []
          this.getSitesSpeechs(this.selectedOptionSpeechs)
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao vincular a fala ao site! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSpeechs() {
      const url = `${config.default.urlBase}/companies/speechs`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.optionsSpeechs = await Promise.all(
            response.data.map(item => {
              return {
                value: item.id,
                text: item.description
              }
            })
          )

          if (this.optionsSpeechs.length == 1) {
            this.selectedOptionSpeechs = this.optionsSpeechs[0].value
            this.onSpeechChange()
          }
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false

        this.options = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          this.getNotification('Aviso', `${error.response.data.message}`, 'warning')
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os tipos de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getPosSpeechs(id) {
      this.isBusy = true
      const url = `${config.default.urlBase}/speechs/${id}/pos/unbounded`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.clearSelected()
          this.pos = []

          this.pos = response.data
          this.isBusy = false
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false
        this.isBusy = false

        this.pos = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas limpar os dados
          this.pos = []
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os totens permitidos para vínculo de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    },

    async getSitesSpeechs(id) {
      this.isBusy = true
      const url = `${config.default.urlBase}/speechs/${id}/sites/unbounded`

      try {
        const response = await axios({
          url,
          method: 'get',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        console.log({
          getSitesSpeechs: response
        })

        if (response.status == 200) {
          this.clearSelectedSites()
          this.sites = []

          this.sites = response.data
          this.isBusy = false
        }
      } catch (error) {
        console.log({
          error
        })

        this.isLoading = false
        this.isBusy = false

        this.sites = []

        if (!error.response) {
          await this.$alert('Não foi possível conectar-se ao servidor. Verifique a conexão e tente novamente!', 'Erro', 'error')
        }

        if (error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        } else if (error.response.status == 404) {
          // Não exibir alerta para 404, apenas limpar os dados
          this.sites = []
        } else {
          await this.$alert(`Ocorreu um erro ao buscar os sites permitidos para vínculo de fala! ${error.response.data.message}`, 'Aviso', 'warning')
        }
      }
    }
  },

  computed: {
    currentItems() {
      return this.activeTab === 'totem' ? this.pos : this.sites
    },

    currentSelected() {
      return this.activeTab === 'totem' ? this.selected : this.selectedSites
    },

    buttonText() {
      if (this.activeTab === 'totem') {
        return 'Gravar Vínculo Totem'
      } else {
        return 'Gravar Vínculo Site'
      }
    },

    hasData() {
      if (this.activeTab === 'totem') {
        return this.pos && this.pos.length > 0
      } else {
        return this.sites && this.sites.length > 0
      }
    }
  },

  async beforeMount() {
    this.isLoading = true
    this.token = sessionStorage.getItem('token')

    this.activeTab = 'totem'
    await this.getSpeechs()
    this.isLoading = false
  }
}
